import React, { ReactElement } from 'react';
import { IconProps } from '../../../../types';

const SmartFormIcon = ({ className }: IconProps): ReactElement => (
  <svg
    className={className || 'w-6 h-6 mr-3'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path
      d="M11.5455 5H4.22222C2.99492 5 2 5.89543 2 7V17C2 18.1046 2.99492 19 4.22222 19H11.5455M11.5455 5H19.7778C21.0051 5 22 5.89543 22 7V17C22 18.1046 21.0051 19 19.7778 19H11.5455M11.5455 5V19M14.2727 9H19.2222M19.2222 12H14.2727M19.2222 15.5H18"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SmartFormIcon;
